module.exports = __webpack_public_path__ + "img/hakhak_block.1bd90e1a.png";